const PartnerProgram = () => import('../views/partnerprogram/PartnerProgram.vue');

export default [
	{
		path: '/partnerprogram',
		name: 'partnerprogram',
		component: PartnerProgram,
		meta: { partnerHost: true },
	},
];
